import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { select, Store } from '@ngrx/store';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { filter, map, take } from 'rxjs/operators';
import { getOpenPlatformProducts } from '../../../selectors/products.selectors';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { LoadPumpCapacityAction } from '../../../actions/single-catalogs.actions';
import { makeReference } from '@ordersnproducts/utils/mix-reference';

@Injectable()
export class LoadSingleCatalogsPumpCapacity implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Handles the field change event for the form.
   *
   * @param value - The new value of the field.
   * @param formGroup - The form group containing the field.
   * @param form - The configurable form component.
   *
   * This method listens for changes in the specified field, filters the products
   * based on the new value, and dispatches a LoadPumpCapacityAction if a matching
   * product is found.
   */
  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOpenPlatformProducts),
        filter((products) => {
          const shouldFilter = !!value && !!products.length;
          return shouldFilter;
        }),
        take(1),
        map((products) => {
          const product = products.find((p) => makeReference(p) === value);
          return product;
        }),
        map((product) => {
          if (product) {
            this.store.dispatch(new LoadPumpCapacityAction());
          }
        }),
      )
      .subscribe();
  }
}
